import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Phone, Mail, ArrowRight } from 'lucide-react';
import { cityDriver } from '../assets/images';

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-24">
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-primary-950 mb-6">
                {t('home.title')}
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                {t('home.subtitle')}
              </p>
              <button
                className="inline-block px-8 py-3.5 bg-black hover:bg-gray-900 text-white font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
              >
                {t('home.contact')}
              </button>
            </div>
            <div className="relative">
              <img 
                src={cityDriver} 
                alt="Car illustration" 
                className="w-full h-auto"
              />
            </div>
          </div>

          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary-950 mb-6">
              {t('home.decision')}
            </h2>
            <p className="text-lg text-gray-600">
              {t('home.objective')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-semibold mb-4">{t('home.dealers.title')}</h3>
              <p className="text-gray-600 mb-4">{t('home.dealers.description')}</p>
              <Link to="/concessionnaires" className="inline-flex items-center text-black hover:text-gray-700">
                <span>{t('services.learnMore')}</span>
                <ArrowRight size={16} className="ml-2" />
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-semibold mb-4">{t('home.thirdChance.title')}</h3>
              <p className="text-gray-600 mb-4">{t('home.thirdChance.description')}</p>
              <Link to="/financement" className="inline-flex items-center text-black hover:text-gray-700">
                <span>{t('services.learnMore')}</span>
                <ArrowRight size={16} className="ml-2" />
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-semibold mb-4">{t('home.guaranteed.title')}</h3>
              <p className="text-gray-600 mb-4">{t('home.guaranteed.description')}</p>
              <Link to="/financement" className="inline-flex items-center text-black hover:text-gray-700">
                <span>{t('services.learnMore')}</span>
                <ArrowRight size={16} className="ml-2" />
              </Link>
            </div>
          </div>

          <div className="mt-24">
            <h2 className="text-3xl font-bold mb-8">{t('home.questions')}</h2>
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <Phone className="text-black" size={20} />
                <span>450 805-3277</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="text-black" size={20} />
                <span>info@financesunshine.com</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;